"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useCallback, useContext, useEffect, useMemo, useState } from "react";
interface PylonContextValue {
  isOpen: boolean;
  toggleChat: () => void;
}
const PylonContext = createContext<PylonContextValue | null>(null);
export function PylonContextProvider(t0) {
  const $ = _c(10);
  const {
    children
  } = t0;
  const [isOpen, setIsOpen] = useState(false);
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      if (typeof window === "undefined" || !window.Pylon) {
        return;
      }
      const handleShow = () => {
        setIsOpen(true);
      };
      const handleHide = () => {
        setIsOpen(false);
      };
      window.Pylon("onShow", handleShow);
      window.Pylon("onHide", handleHide);
      return _temp;
    };
    t2 = [];
    $[0] = t1;
    $[1] = t2;
  } else {
    t1 = $[0];
    t2 = $[1];
  }
  useEffect(t1, t2);
  let t3;
  if ($[2] !== isOpen) {
    t3 = () => {
      if (typeof window !== "undefined" && window.Pylon) {
        if (isOpen) {
          window.Pylon("hide");
        } else {
          window.Pylon("show");
        }
      }
    };
    $[2] = isOpen;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const toggleChat = t3;
  let t4;
  if ($[4] !== isOpen || $[5] !== toggleChat) {
    t4 = {
      isOpen,
      toggleChat
    };
    $[4] = isOpen;
    $[5] = toggleChat;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const value = t4;
  let t5;
  if ($[7] !== children || $[8] !== value) {
    t5 = <PylonContext.Provider value={value}>{children}</PylonContext.Provider>;
    $[7] = children;
    $[8] = value;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
}
function _temp() {
  if (typeof window !== "undefined" && window.Pylon) {
    window.Pylon("onShow", null);
    window.Pylon("onHide", null);
  }
}
export function usePylonContext() {
  const context = useContext(PylonContext);
  if (!context) {
    throw new Error("usePylonContext must be used within a PylonContextProvider");
  }
  return context;
}

/**
 * Safe version that returns a no-op if used outside of PylonContextProvider.
 * Use this for components that may render outside authenticated context.
 */
export function usePylonContextSafe() {
  const $ = _c(2);
  const context = useContext(PylonContext);
  let t0;
  if ($[0] !== context) {
    t0 = context ?? {
      isOpen: false,
      toggleChat: _temp2
    };
    $[0] = context;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
function _temp2() {}